"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyEffects_OnKilledEventHandlerScript = void 0;
const Registries_1 = require("../../core/state/Registries");
const Random_1 = require("../../utils/Random");
let ApplyEffects_OnKilledEventHandlerScript = class ApplyEffects_OnKilledEventHandlerScript {
    run(sequence, container, handler, event) {
        const targets = handler.args.scriptArgs.target === "killer" ? [event.args.killer]
            : container.selectLivingTargets(event.subject, handler.args.scriptArgs.target);
        const selectedEffects = handler.args.scriptArgs.effects
            .filter(({ percentChance = 100 }) => (0, Random_1.randomPercent)() <= percentChance);
        targets.forEach(targetId => {
            container.applyBuffs({
                sequence,
                creatorId: event.subject,
                targetId,
                effects: selectedEffects.filter(effect => !effect.effect.harmful)
            });
            container.applyDebuffs({
                sequence,
                attackerId: event.subject,
                targetId,
                effects: selectedEffects.filter(effect => effect.effect.harmful)
            });
        });
    }
};
ApplyEffects_OnKilledEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("ApplyEffects_OnKilled")
], ApplyEffects_OnKilledEventHandlerScript);
exports.ApplyEffects_OnKilledEventHandlerScript = ApplyEffects_OnKilledEventHandlerScript;
